import PropTypes from 'prop-types';

export const answerType = PropTypes.oneOf([
  'valueString',
  'valueDate',
  'valueInteger',
  'valueTime',
  'valueCoding',
]);
